import {
  FETCH_LANGUAGE_REQUEST,
  FETCH_LANGUAGE_SUCCESS,
  FETCH_LANGUAGE_FAILURE,

  CREATE_LANGUAGE_REQUEST,
  CREATE_LANGUAGE_SUCCESS,
  CREATE_LANGUAGE_FAIL,
  CREATE_LANGUAGE_RESET,

  DELETE_LANGUAGE_REQUEST,
  DELETE_LANGUAGE_SUCCESS,
  DELETE_LANGUAGE_FAIL,
  DELETE_LANGUAGE_RESET,

  UPDATE_LANGUAGE_REQUEST,
  UPDATE_LANGUAGE_SUCCESS,
  UPDATE_LANGUAGE_FAIL,
  UPDATE_LANGUAGE_RESET
} from '../constants/languageConstants';

const initialState = {
  loading: false,
  languages: [],
  error: null
};

// Tworzenie języka
export const languageCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_LANGUAGE_REQUEST:
      return { loading: true };
    case CREATE_LANGUAGE_SUCCESS:
      return { loading: false, success: true };
    case CREATE_LANGUAGE_FAIL:
      return { loading: false, error: action.payload };
    case CREATE_LANGUAGE_RESET:
      return {};
    default:
      return state;
  }
};

// Pobieranie języków
export const languageListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LANGUAGE_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_LANGUAGE_SUCCESS:
      // Zabezpieczenie: jeśli payload to obiekt, zamień go w tablicę
      return {
        ...state,
        loading: false,
        languages: Array.isArray(action.payload)
          ? action.payload
          : [action.payload]
      };

    case FETCH_LANGUAGE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

// Usuwanie języka
export const languageDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_LANGUAGE_REQUEST:
      return { loading: true };
    case DELETE_LANGUAGE_SUCCESS:
      return { loading: false, success: true };
    case DELETE_LANGUAGE_FAIL:
      return { loading: false, error: action.payload };
    case DELETE_LANGUAGE_RESET:
      return {};
    default:
      return state;
  }
};

export const languageUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_LANGUAGE_REQUEST:
      return { loading: true };
    case UPDATE_LANGUAGE_SUCCESS:
      return { loading: false, success: true };
    case UPDATE_LANGUAGE_FAIL:
      return { loading: false, error: action.payload };
    case UPDATE_LANGUAGE_RESET:
      return {};
    default:
      return state;
  }
};